import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Database } from '../../Master/database/database';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})

export class ArchivedashboardService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {

  }

  getArchiveDataList(details): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/ArchiveDashboard/GetArchiveDataList', details);
  }

}
